import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltInlineCommentsSectionFilterDropdownContentWireframe from './VeltInlineCommentsSectionFilterDropdownContentWireframe/VeltInlineCommentsSectionFilterDropdownContentWireframe';
import VeltInlineCommentsSectionFilterDropdownTriggerWireframe from './VeltInlineCommentsSectionFilterDropdownTriggerWireframe/VeltInlineCommentsSectionFilterDropdownTriggerWireframe';
var VeltInlineCommentsSectionFilterDropdownWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-filter-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltInlineCommentsSectionFilterDropdownWireframe.Content = VeltInlineCommentsSectionFilterDropdownContentWireframe;
VeltInlineCommentsSectionFilterDropdownWireframe.Trigger = VeltInlineCommentsSectionFilterDropdownTriggerWireframe;
export default VeltInlineCommentsSectionFilterDropdownWireframe;
